import styled from "styled-components"
import Box from "~/components/UI/Box"
import Text from "~/components/UI/Text"
import SharedTitle from "~/components/UI/SharedTitle"
import { useTranslation } from "~/i18n"
import Input from "../UI/Input"
import Link from "../UI/Link"
import Button from "../UI/Button"
import state from "./State"
import { observer } from 'mobx-react-lite'
import Head from "next/head"
import { useEffect, useState } from "react"
import getConfig from "next/config"
import { runInAction } from 'mobx'
import breakpoints from "../UI/breakpoints"
const MyContainer = styled(Box)`
  margin: 50px 0;
  padding: 0 20px;
  ${breakpoints.md} {
    padding: 0
  }
`

const CDSearchForm = () => {
  const [t] = useTranslation()
  const [id, setID] = useState('')

  const onChange = (evt: any) => {
    state.query = evt.target.value
  }

  const verifyCallback = (response: string) => {
    runInAction(() => state.g_response = response)
  }

  const onSearch = async () => {
    await state.search()
    if (state.error) {
      setID(btoa(Math.random().toString()))
    }
  }

  useEffect(() => {
    setID(btoa(Math.random().toString()))
  }, [])

  useEffect(() => {
    const initCaptcha = () => {
      if ((window as any)?.grecaptcha?.render && id) {
        const { publicRuntimeConfig } = getConfig();
        const { CAPTCHA } = publicRuntimeConfig;
        (window as any).grecaptcha.render(id, {
          'sitekey': CAPTCHA,
          'callback': verifyCallback,
        });
      } else {
        setTimeout(initCaptcha, 500)
      }
    }

    initCaptcha()
  }, [id])

  return (
    <MyContainer flex column align='center' justify='center'>
      <Head>
        <meta property="og:title" content={t('Kiểm tra thông tin CCTG')} />
        <script src="https://www.google.com/recaptcha/api.js" async defer></script>
      </Head>
      <SharedTitle centered>
        {t('Kiểm tra thông tin chứng chỉ tiền gửi')}
      </SharedTitle>
      <Text margin='18px 0' bold size={24} centered>
        {t('Vui lòng nhập số seri để kiểm tra')}
      </Text>
      <Input onChange={onChange} error={state.error} autoFocus style={{ textAlign: "center", maxWidth: 480 }} />
      {
        state.error && (
          <Text margin='8px 0' style={{ maxWidth: 480 }} centered color='#ff5a5f'>
            {t('Rất tiếc chúng tôi không tìm thấy chứng chỉ tiền gửi với số seri này. Vui lòng kiểm tra và thử lại.')}
          </Text>
        )
      }
      <Link target='_blank' href='https://infina.vn/ho-tro/dau-tu/huong-dan-xem-so-seri-cua-chung-chi-tien-gui-tren-app-infina/' style={{ margin: '20px 0' }}>
        {t('Cách xem số seri của Chứng chỉ tiền gửi >')}
      </Link>
      <div key={id} id={id}></div>
      {state.requireCaptcha === true && (
        <Text color='red'>
          {t('Bắt buộc')}
        </Text>
      )}

      {state.loading ? (
        <Text margin='20px 0 0 0'>
          Đang xử lý...
        </Text>
      ) : (
          <Button margin='20px 0 0 0' onClick={onSearch} maxWidth='320px' style={{ width: '100%' }} primary border='0'>
            <Text color='#fff'>
              {t('Xem Kết Quả')}
            </Text>
          </Button>
        )}
    </MyContainer>
  )
}

export default observer(CDSearchForm)
